import React from 'react';

import { Action } from 'state';
import Field from 'types/Field';
import Section from 'types/Section';
import TextFieldPreview from './TextFieldPreview';

interface TextFieldPreviewProps {
  field: Field;
  section: Section;
  dispatch: (action: Action) => void;
}

const TextAreaFieldPreview: React.FC<TextFieldPreviewProps> = ({ field, section, dispatch }) => {
  return <TextFieldPreview multiline field={field} section={section} dispatch={dispatch} />;
};

export default TextAreaFieldPreview;
